import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { TrafficSelectionSidebar } from "./TrafficSelectionSidebar";
import { trafficClickResolver } from "./trafficClickResolver";
import { TrafficLayerSummary } from "./TrafficLayerSummary";

export const TrafficLayerType: LayerType = {
  ...ConstraintsLayerType,
  LayerSummary: TrafficLayerSummary,
  Printable: undefined,
  clickResolver: trafficClickResolver,
  SelectionSidebar: TrafficSelectionSidebar,
};
